<template>
  <div class="timeData">
    <div class="rowA">
      <div>
        <div class="english">CULTURE</div>
      </div>
      <div class="chinese">武夷山文化</div>
    </div>
    <div class="rowB">
      <!-- //公告列表 -->
      <div v-show="showList">
        <div class="tableColumn">
          <div class="box_body" style="height:60vh;border:none">
            <div v-for="item in dataSource" :key="item.id" class="tableRow" @click="handleOpen(item.id,item.meta.type,item)">
              <div class="tableBody" style="flex:1">• {{ item.name }}</div>
              <div class="tableBody" style="width:200px;text-align:right">
                {{ item.showTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //公告详情 -->
      <div v-show="!showList" class="leftBody" style="height:66vh;overflow-y: scroll;">
        <!-- <div style="text-align:center">
          <h1>{{ info.title }}</h1>
        </div> -->
        <div style="text-align:center">
          <div style="display: flex;flex-direction: row;justify-content: center;font-size: 1.296vh;font-family: 'Microsoft YaHei'; font-weight: 400;  color: #005a51;text-align: center;">
               <h1>{{ info.title }}</h1> <span style="margin-top:10px;margin-left:50px">阅读次数: {{info.hits ? info.hits : 0}}</span> 
            </div>  
        </div>
        <div v-html="info.details" class="leftBodyFont">
          <!-- {{ info.details }} -->
        </div>
      </div>
      <!-- 温馨提示 -->
    </div>
    <div class="rowC" style="margin-top:2.685vh;margin-left:9.0%;margin-right:1.0416vw">
      <img v-show="!showList" src="@/assets/image/videoback.png" style="width:5vh;height:5vh;cursor:pointer;" @click="handleBack" />
    </div>
  </div>
</template>

<script>
import { getMenuOpenList } from "@/api/common";
import  {addHits}  from "@/util/publicHits";
export default {
  name: "NoticeIndex",
  props: {
    ifshow: {
      type: Boolean,
      default: true
    },
    infoDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataSource: [],
      hintWarm: "",
      showList: true,
      info: {}
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        // 当数值为 1时显示 默认显示菜单的第一个列表
        if (deviceId === 1) {
           this.showList =true;
          this.showDefaultMenu();
        } else {
          this.showList =true;
          this.handleClick(deviceId);
        }

      },
      deep: true,
      immediate: true
    }
  },
  mounted() {

  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    open(item) {
      this.info = item
      this.showList = false
    },
    back() {
      this.info = {}
      this.showList = true
    },
    async showDefaultMenu() {
      let id = 0
      let type = 1
      let current = 1
      let pageSize = 5
      const { code, data } = await getMenuOpenList(id, type, current, pageSize);
      if (code === 200) {
        let arrList = data.records;
        if (arrList.length > 0) {
          this.handleClick(arrList[0].id);
        }
      }
    },
    //标题点击
    async handleClick(id) {
      this.chooseId = id
      let type = 1
      let current = 1
      let pageSize = 1000
      const { code, data } = await getMenuOpenList(id, type, current, pageSize);
      if (code == 200) {
        this.dataSource = data.records;
      }
    },
    //二级点击
    async handleOpen(id, type, item) {
      addHits(id)
      if (type === "catalogue") {
        // 目录
        let type = 1
        let current = 1
        let pageSize = 1000
        const { code, data } = await getMenuOpenList(id, type, current, pageSize);
        if (code == 200) {
          this.dataSource = data.records;
        }
      } else {
        //详情
        this.info = item
        this.showList = false
      }
    },
    handleBack() {
      this.showList = true;
    }
  }
};
</script>

<style scoped>
.leftBodyFont {
  width: 100%;
  /* line-height: 2.314vh; */
}
.leftBody::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
/* 滑块 */
.leftBody::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}
/* 滑槽 */
.leftBody::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
}
.timeData {
  height: 85.555vh;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.timeData .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.timeData .rowB {
  width: 100%;
  margin-top: 3.87%;
  margin-left: 4.24%;
  animation: bounceInRight 2s;
}
.timeData .rowC {
  /* width: 30px; */
  padding: 0px 0.3645vw 0px 0.3645vw;
  height: 26.4814vh;
  line-height: 1.574vh;
  /* background: #d87001; */
  /* position: relative; */
  color: #ffffff;
  animation: bounceInRight 2s;
  font-size: 1.2962vh;
}
.timeData .rowC .layout {
}

.timeData .rowB .topFont {
  font-size: 1.66667vh;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 1.66667vh;
  margin-bottom: 1.388vh;
}

.timeData .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 0.833vh;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}
.timeData .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 0.833vw;
  font-size: 0.833vw;
  font-weight: bold;
  color: #d87001;
}

.tableHeader {
  height: 4.62vh;
  background: #cae6e0;
  display: flex;
  flex-direction: row;
  /* width: 87.04%; */
}
.tableHeaderA {
  width: 25%;
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #4a9183;
  line-height: 1.4814vh;
  text-align: center;
  padding-top: 1.574vh;
  line-height: 1.4814vh;
}

.tableBody {
  /* width: 25%; */
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #666666;
  font-size: 1.4814vh;
  text-align: left;
  padding-top: 1.574vh;
  line-height: 1.111vh;
  /* background: #ffffff; */
  height: 4.6296vh;
  border-bottom: 0.0925vh dashed #bec9df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box_body {
  display: flex;
  flex-direction: column;
  /* width: 87.04%; */
  border-bottom: 0.0925vh solid #bec9df;
  border-left: 0.0925vh solid #bec9df;
  border-right: 0.0925vh solid #bec9df;
  overflow-y: scroll;
}
.box_body::-webkit-scrollbar {
  width: 0.18vw;
  /*height: 4px;*/
}
/* 滑块 */
.box_body::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #c1c1c1;
}
/* 滑槽 */
.box_body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  background: rgba(0, 94, 154, 0);
}
.tableRow {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}
.tableColumn {
  display: flex;
  flex-direction: column;
}
.tableColumn .fontSizeA {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #d87001;
  padding-top: 1.296vh;
}
.tableColumn .fontSizeB {
  font-size: 1.296vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #888888;
}
.refreshImg {
  width: 2.222vh;
  height: 2.222vh;
  position: absolute;
  z-index: 0;
  float: right;
  right: 2.135vw;
}
.refreshFont {
  line-height: 1.4814vh;
  font-size: 1.4814vh;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #4a9183;
  padding-top: 0.4629vh;
  padding-left: 0.46875vw;
  position: absolute;
  z-index: 0;
  float: right;
  right: 0px;
}
.tableTop {
  display: flex;
  flex-direction: row;
  margin-top: 3.703vh;
  position: relative;
  cursor: pointer;
  /* width: 87.04%; */
}
.table-tips {
  width: 100%;
  height: 9.259vh;
  word-wrap: break-word;
  overflow: hidden;

  /* text-overflow: ellipsis; */
}
</style>



// WEBPACK FOOTER //
// src/views/culture/list.vue